/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Fri Nov 29 2024
 **/
export function OpenIcon() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 512 512">
			<path
				fill="#000"
				d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1 0 32c0 8.8 7.2 16 16 16l32 0zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
			/>
		</svg>
	);
}
export function CloseIcon() {
	return (
		<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g opacity="0.88">
				<path
					d="M15.2691 14.2177L20 18.948L24.7309 14.2177C24.9949 13.9538 25.4079 13.9298 25.6989 14.1458L25.7823 14.2177C26.0726 14.508 26.0726 14.9787 25.7823 15.2691L21.052 20L25.7823 24.7309C26.0726 25.0213 26.0726 25.492 25.7823 25.7823C25.492 26.0726 25.0213 26.0726 24.7309 25.7823L20 21.052L15.2691 25.7823C15.0051 26.0462 14.5921 26.0702 14.3011 25.8542L14.2177 25.7823C13.9274 25.492 13.9274 25.0213 14.2177 24.7309L18.948 20L14.2177 15.2691C13.9274 14.9787 13.9274 14.508 14.2177 14.2177C14.508 13.9274 14.9787 13.9274 15.2691 14.2177Z"
					fill="white"
				/>
			</g>
		</svg>
	);
}

export function MinimizeIcon() {
	return (
		<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g opacity="0.88">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M28.2803 12.7803C28.5732 12.4874 28.5732 12.0126 28.2803 11.7197C27.9874 11.4268 27.5126 11.4268 27.2197 11.7197L21.5 17.438V13.9167C21.5 13.5025 21.1642 13.1667 20.75 13.1667C20.3358 13.1667 20 13.5025 20 13.9167V19.25C20 19.6642 20.3358 20 20.75 20H26.0833C26.4975 20 26.8333 19.6642 26.8333 19.25L26.8265 19.1482C26.7768 18.7822 26.463 18.5 26.0833 18.5L22.561 18.499L28.2803 12.7803ZM20 20.75C20 20.3358 19.6642 20 19.25 20H13.9167C13.5025 20 13.1667 20.3358 13.1667 20.75L13.1735 20.8518C13.2232 21.2178 13.537 21.5 13.9167 21.5H17.438L11.7197 27.2197C11.4268 27.5126 11.4268 27.9874 11.7197 28.2803C12.0126 28.5732 12.4874 28.5732 12.7803 28.2803L18.499 22.561L18.5 26.0833C18.5 26.4975 18.8358 26.8333 19.25 26.8333C19.6642 26.8333 20 26.4975 20 26.0833V20.75Z"
					fill="white"
				/>
			</g>
		</svg>
	);
}

export function MaximizeIcon() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" height="14" width="12.25" viewBox="0 0 448 512">
			<path
				fill="#ffffff"
				d="M32 32C14.3 32 0 46.3 0 64l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-64zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-96 0zM448 352c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-96z"
			/>
		</svg>
	);
}
